/**
 * Echobot Feed Avatar
 * Special avatar for Echobot posts in the feed/stream
 */

import React from 'react';

interface EchobotFeedAvatarProps {
  size?: 'small' | 'medium' | 'large';
  animated?: boolean;
}

const EchobotFeedAvatar: React.FC<EchobotFeedAvatarProps> = ({
  size = 'medium',
  animated = true
}) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-10 h-10',
    large: 'w-12 h-12'
  };

  const iconSizes = {
    small: 'w-4 h-4',
    medium: 'w-5 h-5',
    large: 'w-6 h-6'
  };

  return (
    <div
      className={`${sizeClasses[size]} rounded-full bg-gradient-to-br from-accent to-info flex items-center justify-center shadow-card border-2 border-white ${
        animated ? 'animate-pulse' : ''
      }`}
      title="Echobot"
    >
      {/* Robot Icon */}
      <div className="text-txt-inverted text-xl">🤖</div>
      
      {/* Animated Glow Effect */}
      {animated && (
        <div className="absolute inset-0 rounded-full bg-accent opacity-20 animate-ping" />
      )}

      <style>{`
        @keyframes gentle-pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.9; transform: scale(1.05); }
        }

        .animate-pulse {
          animation: gentle-pulse 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default EchobotFeedAvatar;

